import { render, staticRenderFns } from "./TrackingWaybillAddy.vue?vue&type=template&id=1c5c7772&scoped=true&"
import script from "./TrackingWaybillAddy.vue?vue&type=script&lang=js&"
export * from "./TrackingWaybillAddy.vue?vue&type=script&lang=js&"
import style0 from "./TrackingWaybillAddy.vue?vue&type=style&index=0&id=1c5c7772&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c7772",
  null
  
)

export default component.exports